import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app-subscription-wizard.component.html',
    styleUrls: ['./app-subscription-wizard.component.scss'],
    imports: [
        RouterOutlet,
    ]
})
export class AppSubscriptionWizardComponent {
  title = 'suscription ';
}
